import { render, staticRenderFns } from "./MargemConsignavel.vue?vue&type=template&id=731a90f7&"
import script from "./MargemConsignavel.vue?vue&type=script&lang=js&"
export * from "./MargemConsignavel.vue?vue&type=script&lang=js&"
import style0 from "./MargemConsignavel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports